<template>
	<iframe src="https://picayune-record-a8e.notion.site/Help-fbdff2d5d028463fa846b008ba3c5d43" frameborder="0" style="overflow:hidden;height:100%;width:100%" height="100%" width="100%"></iframe>
</template>

<script>
export default {
	mounted: function() 
    {
        window.analytics.page('Help');
	}
}
</script>

<style scoped>

</style>
